import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Controller, useForm } from "react-hook-form";
import { useLead } from "../../../../core";
import api from "../../../../api";

export interface FormProps {
  reason: string;
  nextContactDate?: Date;
  comment?: string;
  contactAfter?: string;
}

const AcceptAsLost: React.FunctionComponent<{
  leadId: string;
}> = (props) => {
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);
  const { updating, acceptMarkAsLost, getLead } = useLead(api.lead);

  const { control, handleSubmit } = useForm<FormProps>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderModel = () => {
    return isModelOpen ? (
      <>
        <div
          className="modal fade show in mark-as-lost"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <p>
                          Are you sure want to accept the lost request for this
                          Opportunity
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div className="form-group font-weight-semibold mb-3 text-left">
                          <label htmlFor="" className="font-sm text-uppercase">
                            Comments
                          </label>
                          <Controller
                            control={control}
                            name="comment"
                            render={({ onChange, value, name }) => (
                              <input
                                type="text"
                                className="form-control rounded-sm font-weight-semibold"
                                placeholder="Enter comment"
                                name={name}
                                value={value}
                                onChange={onChange}
                                id="comment"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-auto mr-auto">
                        <button
                          type="button"
                          className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                          onClick={() => setIsModelOpen(false)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-auto">
                        <button
                          type="submit"
                          className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                          disabled={updating}
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };
  const onSubmit = async (data: FormProps) => {
    acceptMarkAsLost(props.leadId, { comment: data.comment }, () => {
      toastr.success(
        "Success",
        "Lead mark as lost requset accepted successfully"
      );
      getLead(props.leadId);
      setIsModelOpen(false);
    });
  };

  return (
    <>
      <button
        onClick={() => setIsModelOpen(true)}
        className="btn btn-outline-primary px-lg-4 px-2 mb-sm-0 mb-1 font-weight-semibold"
      >
        Accept
      </button>
      {renderModel()}
    </>
  );
};

export default AcceptAsLost;
